<template>
  <v-card>
    <v-app-bar flat dense>
      <v-toolbar-title
        ><span class="title">{{
          $t("menu.api.apiApps")
        }}</span></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn outlined small color="indigo" @click="dialog = true">
        {{ $t("table.app.newApp") }}
      </v-btn>
      <v-btn icon @click="getData">
        <v-icon color="indigo">refresh</v-icon>
      </v-btn>
      <!--<v-btn icon> <v-icon>more_vert</v-icon> </v-btn>-->
    </v-app-bar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table
        dense
        :headers="headers"
        :items="listApps"
        item-key="id"
        :options.sync="pagination"
        :server-items-length="totalApps"
        :loading="loading"
        :footer-props="footerOptions"
        :mobile-breakpoint="0"
      >
        <template v-slot:item="props">
          <tr>
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-left" style="word-break: break-all;">
              {{ props.item.token }}
            </td>
            <td class="text-xs-right">{{ props.item.order_expired_time }}</td>
            <td class="text-xs-right">{{ props.item.deviation }}</td>
            <td class="text-xs-left">
              {{ props.item.created_at | moment("YYYY-MM-DD HH:mm:ss") }}
            </td>
            <td class="justify-center ">
              <v-icon small class="mr-2" @click="editItem(props.item)">
                edit
              </v-icon>
              <v-icon color="red" small @click="removeApp(props.item)">
                delete
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card-text>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-form name="formApp" ref="formApp" :model="newApp">
                <v-text-field
                  :label="$t('table.app.title') + ' *'"
                  v-model="newApp.title"
                  :counter="50"
                  required
                ></v-text-field>

                <v-text-field
                  :label="$t('table.app.deviation') + ' *'"
                  v-model="newApp.deviation"
                  type="number"
                  required
                  hint="From 0 to 0.02"
                  persistent-hint
                ></v-text-field>

                <v-subheader class="pl-0">{{
                  $t("table.app.expiredTime")
                }}</v-subheader>

                <v-slider
                  v-model="newApp.order_expired_time"
                  :max="1800"
                  :min="30"
                  :step="30"
                  thumb-label="always"
                ></v-slider>
              </v-form>
            </v-flex>
          </v-layout>
          <small>{{ $t("common.noticeRequiredField") }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel">{{
            $t("button.cancel")
          }}</v-btn>
          <v-btn color="blue darken-1" text @click="submitApp">{{
            $t("button.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TableApp",
  data(self) {
    return {
      dialog: false,
      loading: false,
      pagination: {
        page: 1,
        itemsPerPage: 10
      },
      footerOptions: {
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageOptions: [5, 10, 15, 20, 25, 30]
      },
      headers: [
        { text: self.$t("table.app.title"), sortable: false, width: "200" },
        { text: self.$t("table.app.token"), sortable: false, width: "500" },
        {
          text: self.$t("table.app.expiredTime"),
          sortable: false,
          width: "200"
        },
        { text: self.$t("table.app.deviation"), sortable: false, width: "150" },
        { text: self.$t("common.createdAt"), sortable: false, width: "150" },
        { text: "", sortable: false }
      ],
      editedIndex: -1,
      newApp: {
        title: "",
        order_expired_time: 600,
        deviation: 0.00001
      },
      defaultItem: {
        title: "",
        order_expired_time: 600,
        deviation: 0.00001
      },
      snackbar: {
        show: false,
        text: "",
        color: ""
      }
    };
  },
  computed: {
    ...mapGetters(["listApps", "totalApps"]),
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("table.app.newApp")
        : this.$t("table.app.editApp");
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$store
        .dispatch("fetchListApp", {
          page: this.pagination.page,
          per_page: this.pagination.itemsPerPage
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    submitApp() {
      if (this.editedIndex > -1) {
        this.$store
          .dispatch("updateApp", this.newApp)
          .then(() => {
            this.$store.dispatch("fetchListApp", {
              page: this.pagination.page,
              per_page: this.pagination.itemsPerPage
            });
            this.snackbar = {
              show: true,
              color: "green",
              text: "Successfully."
            };
            this.close();
          })
          .catch(error => {
            this.snackbar = {
              show: true,
              color: "red",
              text: error.response.data.message
            };
          });
      } else {
        this.$store
          .dispatch("createNewApp", this.newApp)
          .then(() => {
            this.$store.dispatch("fetchListApp", {
              page: this.pagination.page,
              per_page: this.pagination.itemsPerPage
            });
            this.snackbar = {
              show: true,
              color: "green",
              text: "Successfully."
            };
            this.close();
          })
          .catch(error => {
            this.snackbar = {
              show: true,
              color: "red",
              text: error.response.data.error
            };
          });
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.newApp = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    editItem(item) {
      this.editedIndex = this.listApps.indexOf(item);
      this.newApp = Object.assign({}, item);
      this.dialog = true;
    },
    removeApp(item) {
      if (confirm(this.$t("dialog.confirmDeleteItem"))) {
        this.$store
          .dispatch("deleteApp", item.id)
          .then(() => {
            this.$store.dispatch("fetchListApp", {
              page: this.pagination.page,
              per_page: this.pagination.itemsPerPage
            });
            this.snackbar = {
              show: true,
              color: "green",
              text: "Successfully."
            };
          })
          .catch(error => {
            this.snackbar = {
              show: true,
              color: "red",
              text: error.response.data.error
            };
          });
      }
    },
    cancel() {
      this.close();
      // this.$refs.formApp.reset();
    }
  },
  mounted() {
    this.getData();
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true
    }
  }
};
</script>
